import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { EMPTY_REVSHOP_OVERRIDE_MARKUP } from 'domains/markupDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OverrideItemForm from './OverrideItemForm';
import OverrideTable from './OverrideTable';

const RevshopOverrideTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.markup.curOverrideMarkup);

  return (
    <>
      <PageHeader
        ghost={false}
        extra={[
          <RevxButton
            key="create"
            type="primary"
            onClick={() => {
              dispatch.markup.setState({
                curOverrideMarkup: EMPTY_REVSHOP_OVERRIDE_MARKUP,
              });
            }}
          >
            {t('platform.markup.titles.create')}
          </RevxButton>,
        ]}
      />

      {curItem && <OverrideItemForm />}
      <OverrideTable mode="revshop" />
    </>
  );
};

export default RevshopOverrideTab;
